import { Outlet } from "react-router-dom";
import Footer from "./footer";

export default function Layout() {
  return (
    <div className="flex flex-col min-h-screen">
      {/* Optional: Header goes here */}
      <main className="flex-grow">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
